import React, { useRef, useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateCheckbox,
  setSelectedFilters,
  // removeFilter,
  // restoreFilter,
  setSegmentationDataRedux,
  updateCustomSegmentations,
  setQualifyingQuestionsData,
} from "../../../redux/featuresSlice/segmantation"; // Adjust path
import images from "../../../images";
import { CheckboxCommon } from "../../../components/common/CheckBox/CheckboxCommon";
import CommonModal from "../../../components/common/Modal/ModalCommon";
import Button from "../../../components/common/Button/Button";
import { FormSelectSegmentation } from "../../../components/common/Select/FormSelectSegmentation";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import { useGetListSegmentionQuery } from "../../../services/apiSlice";
import LoadingCommon from "../../../components/common/LoadingStatus/LoadingCommon";

const SegmentationFilters = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    custom_segmentations = [],
    selectedFilters = [],
    segmentationDataRedux = [],
    qualifyingQuestionsData = [],
  } = useSelector((state) => state.filters || {});
  const removeSegmanModalRef = useRef();
  const addFilterModalRef = useRef();
  const [currentFilterKey, setCurrentFilterKey] = useState(null);
  const [modalSelectedGroups, setModalSelectedGroups] = useState(new Set());
  const [isEditingQualifying, setIsEditingQualifying] = useState(false);
  // const [previousOptions, setPreviousOptions] = useState({});

  const { data: segmentDataList, isLoading: isLoadingSegmentData } =
    useGetListSegmentionQuery({
      limit: 10,
      page: 1,
    });

  const defaultQualifyingGroup = useMemo(
    () => ({
      title: "What was your dining options",
      consumer_map_field: "custom",
      options: [
        {
          title: "Dine in",
          checked: true,
          description: "",
          value: "Dine in",
          min_value: 0,
          max_value: 0,
        },
        {
          title: "Take out",
          checked: true,
          description: "",
          value: "Take out",
          min_value: 0,
          max_value: 0,
        },
        {
          title: "Delivery",
          checked: true,
          description: "",
          value: "Delivery",
          min_value: 0,
          max_value: 0,
        },
        {
          title: "Drive-thru",
          checked: false,
          description: "",
          value: "Drive-thru",
          min_value: 0,
          max_value: 0,
        },
      ],
      isCustom: false,
    }),
    []
  );

  const [qualifyingGroup, setQualifyingGroup] = useState(
    defaultQualifyingGroup
  );

  useEffect(() => {
    if (qualifyingQuestionsData.length > 0) {
      const reduxQualifyingData = qualifyingQuestionsData[0];
      setQualifyingGroup({
        title: reduxQualifyingData.name || "Qualifying Question",
        consumer_map_field: reduxQualifyingData.consumer_map_field || "custom",
        options: reduxQualifyingData.options.map((opt) => ({
          title: opt.title,
          checked: opt.checked,
          description: opt.description || "",
          value: opt.value || opt.title,
          min_value: opt.min_value || 0,
          max_value: opt.max_value || 0,
        })),
        isCustom: true,
      });
    } else {
      // setQualifyingGroup(defaultQualifyingGroup);
    }
  }, [qualifyingQuestionsData, defaultQualifyingGroup]);

  useEffect(() => {
    if (
      !segmentationDataRedux.length &&
      segmentDataList &&
      segmentDataList.length > 0
    ) {
      dispatch(setSegmentationDataRedux(segmentDataList.data || []));
    }
  }, [segmentDataList, segmentationDataRedux.length, dispatch]);

  const filterOptions = Array.isArray(segmentationDataRedux)
    ? segmentationDataRedux
        .map((segment) => ({
          value: segment.consumer_map_field,
          label: segment.name,
        }))
        .sort((a, b) => {
          const order = { age: 1, gender: 2 };
          return (order[a.value] || 3) - (order[b.value] || 3);
        })
    : [];

  const sortOptionsWithOthersLast = (options) => {
    if (!Array.isArray(options)) return [];
    const indexedOptions = options.map((option, index) => ({
      option,
      originalIndex: index,
    }));

    indexedOptions.sort((a, b) => {
      const aIsOthers = a.option.title?.toLowerCase() === "others";
      const bIsOthers = b.option.title?.toLowerCase() === "others";
      if (aIsOthers && !bIsOthers) return 1;
      if (!aIsOthers && bIsOthers) return -1;
      return a.originalIndex - b.originalIndex;
    });

    return indexedOptions.map(({ option }) => option);
  };
  const handleFilterSelect = (value) => {
    if (!value || value.length === 0) {
      dispatch(setSelectedFilters([]));
      dispatch(setQualifyingQuestionsData([]));
      return;
    }

    const prevFilters = [...selectedFilters];

    const newlyAddedFilters = value.filter(
      (filter) => !prevFilters.includes(filter)
    );

    const removedFilters = prevFilters.filter(
      (filter) => !value.includes(filter)
    );

    if (removedFilters.length > 0) {
      removedFilters.forEach((filterKey) => {
        if (filterKey === "custom") {
          dispatch(setQualifyingQuestionsData([]));
          setQualifyingGroup({ ...defaultQualifyingGroup, isCustom: false });
          const updatedCustomSegmentations = custom_segmentations.filter(
            (seg) => seg.consumer_map_field !== "custom"
          );
          dispatch(updateCustomSegmentations(updatedCustomSegmentations));
        }
      });
    }

    if (newlyAddedFilters.includes("custom") && !qualifyingGroup.isCustom) {
      const newSegment = {
        id: uuidv4(),
        name: qualifyingGroup.title,
        type: "enum",
        description: "",
        category: "custom",
        consumer_map_field: "custom",
        segmentation_options: qualifyingGroup.options.map((opt) => ({
          min_value: opt.min_value || 0,
          max_value: opt.max_value || 0,
          value: opt.value,
          title: opt.title,
          description: opt.description,
        })),
        options: qualifyingGroup.options.map((opt) => ({
          min_value: opt.min_value || 0,
          max_value: opt.max_value || 0,
          value: opt.value,
          title: opt.title,
          description: opt.description,
          checked: true,
        })),
        questions: [],
      };

      if (
        !custom_segmentations.some(
          (seg) =>
            seg.consumer_map_field === "custom" &&
            seg.name === qualifyingGroup.title
        )
      ) {
        dispatch(
          updateCustomSegmentations([...custom_segmentations, newSegment])
        );
        dispatch(setQualifyingQuestionsData([newSegment]));
        setQualifyingGroup((prev) => ({ ...prev, isCustom: true }));
      }
    }

    if (newlyAddedFilters.length > 0) {
      const newRegularFilters = newlyAddedFilters.filter(
        (filter) => filter !== "custom"
      );

      if (newRegularFilters.length > 0) {
        newRegularFilters.forEach((filterKey) => {
          setTimeout(() => {
            const segment = custom_segmentations.find(
              (s) => s.consumer_map_field === filterKey
            );

            if (segment) {
              segment.options.forEach((_, index) => {
                dispatch(
                  updateCheckbox({
                    filterKey,
                    index,
                    checked: true,
                  })
                );
              });
            }
          }, 0);
        });
      }
    }

    const updatedValue = [...new Set(value)];
    dispatch(setSelectedFilters(updatedValue));
  };
  // const handleCheckboxChange = (filterKey, sortedIndex) => {
  //   const segment = custom_segmentations.find(
  //     (s) => s.consumer_map_field === filterKey
  //   );
  //   if (!segment) return;

  //   const sortedOptions = sortOptionsWithOthersLast(segment.options);
  //   const originalIndex = segment.options.findIndex(
  //     (opt) => opt === sortedOptions[sortedIndex]
  //   );

  //   const updatedOptions = [...segment.options];

  //   const willAllBeUnchecked = updatedOptions.every((item) => !item.checked);
  //   if (willAllBeUnchecked) {
  //     setPreviousOptions({
  //       filterKey,
  //       options: segment.options.map((opt) => ({ ...opt })),
  //     });
  //     setCurrentFilterKey(filterKey);
  //     removeSegmanModalRef.current.openModal();
  //   }

  //   updatedOptions[originalIndex] = {
  //     ...updatedOptions[originalIndex],
  //     checked: !updatedOptions[originalIndex].checked,
  //   };
  //   dispatch(updateCheckbox({ filterKey, index: originalIndex }));

  //   const noOptionsSelected = updatedOptions.every((item) => !item.checked);

  //   if (noOptionsSelected) {
  //     setCurrentFilterKey(filterKey);
  //     removeSegmanModalRef.current.openModal();
  //   }

  //   if (filterKey === "custom") {
  //     const updatedQualifyingData = qualifyingQuestionsData.map((q) =>
  //       q.consumer_map_field === filterKey
  //         ? { ...q, options: updatedOptions }
  //         : q
  //     );
  //     dispatch(setQualifyingQuestionsData(updatedQualifyingData));
  //   }
  // };
  const handleCheckboxChange = (filterKey, sortedIndex) => {
    const segment = custom_segmentations.find(
      (s) => s.consumer_map_field === filterKey
    );
    if (!segment) return;

    const sortedOptions = sortOptionsWithOthersLast(segment.options);
    const originalIndex = segment.options.findIndex(
      (opt) => opt === sortedOptions[sortedIndex]
    );

    const currentChecked = segment.options[originalIndex].checked;

    // if (
    //   currentChecked &&
    //   segment.options.every((opt, idx) => idx === originalIndex || !opt.checked)
    // ) {
    //   setPreviousOptions({
    //     filterKey,
    //     options: segment.options.map((opt) => ({ ...opt })),
    //   });
    //   setCurrentFilterKey(filterKey);
    //   return;
    // }

    if (!currentChecked && segment.options.every((opt) => !opt.checked)) {
      dispatch(updateCheckbox({ filterKey, index: originalIndex }));

      if (filterKey === "custom") {
        const updatedOptions = segment.options.map((opt, idx) => ({
          ...opt,
          checked: idx === originalIndex ? true : opt.checked,
        }));

        const updatedQualifyingData = qualifyingQuestionsData.map((q) =>
          q.consumer_map_field === filterKey
            ? { ...q, options: updatedOptions }
            : q
        );
        dispatch(setQualifyingQuestionsData(updatedQualifyingData));
      }
      return;
    }

    dispatch(updateCheckbox({ filterKey, index: originalIndex }));

    if (filterKey === "custom") {
      const updatedOptions = segment.options.map((opt, idx) => ({
        ...opt,
        checked: idx === originalIndex ? !opt.checked : opt.checked,
      }));

      const updatedQualifyingData = qualifyingQuestionsData.map((q) =>
        q.consumer_map_field === filterKey
          ? { ...q, options: updatedOptions }
          : q
      );
      dispatch(setQualifyingQuestionsData(updatedQualifyingData));
    }
  };
  // const handleAllCheckboxChange = (filterKey) => {
  //   const segment = custom_segmentations.find(
  //     (s) => s.consumer_map_field === filterKey
  //   );
  //   if (!segment) return;

  //   const allChecked = segment.options.every((opt) => opt.checked);
  //   const updatedOptions = segment.options.map((opt) => ({
  //     ...opt,
  //     checked: !allChecked,
  //   }));

  //   const noOptionsSelected = updatedOptions.every((item) => !item.checked);
  //   if (noOptionsSelected) {
  //     // setCurrentFilterKey(filterKey);
  //     // removeSegmanModalRef.current.openModal();
  //     setPreviousOptions({
  //       filterKey,
  //       options: segment.options.map((opt) => ({ ...opt })), // Deep copy để lưu trạng thái
  //     });
  //     setCurrentFilterKey(filterKey);
  //     removeSegmanModalRef.current.openModal();
  //   }

  //   segment.options.forEach((_, index) => {
  //     dispatch(
  //       updateCheckbox({
  //         filterKey,
  //         index,
  //         checked: !allChecked,
  //       })
  //     );
  //   });

  //   if (filterKey === "custom") {
  //     const updatedQualifyingData = qualifyingQuestionsData.map((q) =>
  //       q.consumer_map_field === filterKey
  //         ? { ...q, options: updatedOptions }
  //         : q
  //     );
  //     dispatch(setQualifyingQuestionsData(updatedQualifyingData));
  //   }
  // };

  // const onRemoveSegman = () => {
  //   if (currentFilterKey) {
  //     dispatch(removeFilter(currentFilterKey));
  //     removeSegmanModalRef.current.closeModal();
  //     setCurrentFilterKey(null);
  //   }
  // };

  const handleAllCheckboxChange = (filterKey) => {
    const segment = custom_segmentations.find(
      (s) => s.consumer_map_field === filterKey
    );
    if (!segment) return;

    const allChecked = segment.options.every((opt) => opt.checked);
    const updatedOptions = segment.options.map((opt) => ({
      ...opt,
      checked: !allChecked,
    }));

    segment.options.forEach((_, index) => {
      dispatch(
        updateCheckbox({
          filterKey,
          index,
          checked: !allChecked,
        })
      );
    });

    if (filterKey === "custom") {
      const updatedQualifyingData = qualifyingQuestionsData.map((q) =>
        q.consumer_map_field === filterKey
          ? { ...q, options: updatedOptions }
          : q
      );
      dispatch(setQualifyingQuestionsData(updatedQualifyingData));
    }
  };

  // const onRemoveSegman = (filterKey) => {
  //   if (filterKey) {
  //     dispatch(
  //       setSelectedFilters(selectedFilters.filter((f) => f !== filterKey))
  //     );
  //     removeSegmanModalRef.current.closeModal();
  //   }
  // };
  const onRemoveSegman = () => {
    if (currentFilterKey) {
      dispatch(
        setSelectedFilters(
          selectedFilters.filter((f) => f !== currentFilterKey)
        )
      );
      removeSegmanModalRef.current.closeModal();
      setCurrentFilterKey(null);
    }
  };

  // const onKeepSegman = () => {
  //   if (currentFilterKey && previousOptions.filterKey === currentFilterKey) {
  //     const segment = custom_segmentations.find(
  //       (s) => s.consumer_map_field === currentFilterKey
  //     );

  //     if (segment) {
  //       previousOptions.options.forEach((prevOpt, index) => {
  //         dispatch(
  //           updateCheckbox({
  //             filterKey: currentFilterKey,
  //             index,
  //             checked: prevOpt.checked,
  //           })
  //         );
  //       });

  //       if (
  //         currentFilterKey === "custom" &&
  //         qualifyingQuestionsData.length > 0
  //       ) {
  //         const updatedQualifyingData = qualifyingQuestionsData.map((q) =>
  //           q.consumer_map_field === currentFilterKey
  //             ? { ...q, options: previousOptions.options }
  //             : q
  //         );
  //         dispatch(setQualifyingQuestionsData(updatedQualifyingData));
  //       }
  //     }

  //     removeSegmanModalRef.current.closeModal();
  //     setCurrentFilterKey(null);
  //   }
  // };
  const onKeepSegman = () => {
    // if (currentFilterKey && previousOptions.filterKey === currentFilterKey) {
    if (currentFilterKey) {
      // const segmentIndex = custom_segmentations.findIndex(
      //   (s) => s.consumer_map_field === currentFilterKey
      // );

      // if (segmentIndex !== -1) {
      //   const updatedSegmentations = [...custom_segmentations];

      //   // Khôi phục trạng thái của tất cả các checkbox từ previousOptions
      //   previousOptions.options.forEach((prevOpt, index) => {
      //     if (index < updatedSegmentations[segmentIndex].options.length) {
      //       dispatch(
      //         updateCheckbox({
      //           filterKey: currentFilterKey,
      //           index,
      //           checked: prevOpt.checked,
      //         })
      //       );
      //     }
      //   });

      //   // Xử lý đặc biệt cho filter "custom"
      //   if (
      //     currentFilterKey === "custom" &&
      //     qualifyingQuestionsData.length > 0
      //   ) {
      //     const updatedQualifyingData = qualifyingQuestionsData.map((q) =>
      //       q.consumer_map_field === "custom"
      //         ? {
      //             ...q,
      //             options: previousOptions.options.map((opt) => ({
      //               ...opt,
      //               checked: opt.checked,
      //             })),
      //           }
      //         : q
      //     );
      //     dispatch(setQualifyingQuestionsData(updatedQualifyingData));
      //   }
      // }

      // Đóng modal và reset trạng thái
      removeSegmanModalRef.current.closeModal();
      setCurrentFilterKey(null);
    } else {
      console.warn(
        "Cannot restore filter options: Missing currentFilterKey or previousOptions"
      );
      removeSegmanModalRef.current.closeModal();
    }
  };
  const handleToggleGroupSelection = (filterKey) => {
    const newSelectedGroups = new Set(modalSelectedGroups);
    if (newSelectedGroups.has(filterKey)) {
      newSelectedGroups.delete(filterKey);
    } else if (selectedFilters.length + newSelectedGroups.size < 3) {
      newSelectedGroups.add(filterKey);
    }
    setModalSelectedGroups(newSelectedGroups);
  };

  const handleApplySelectedGroups = () => {
    const newFilters = [
      ...selectedFilters,
      ...Array.from(modalSelectedGroups),
    ].slice(0, 3);
    dispatch(setSelectedFilters(newFilters));
    setModalSelectedGroups(new Set());
    addFilterModalRef.current.closeModal();
  };

  const handleQualifyingTitleChange = (e) => {
    setQualifyingGroup((prev) => ({
      ...prev,
      title: e.target.value,
    }));
    const updatedQualifyingData = qualifyingQuestionsData.map((q) =>
      q.consumer_map_field === "custom" ? { ...q, name: e.target.value } : q
    );
    dispatch(setQualifyingQuestionsData(updatedQualifyingData));
  };

  const handleQualifyingOptionChange = (index, field, value) => {
    setQualifyingGroup((prev) => {
      const newOptions = [...prev.options];
      newOptions[index] = { ...newOptions[index], [field]: value };
      if (field === "title") {
        newOptions[index].value = value;
      }
      return { ...prev, options: newOptions };
    });

    const updatedQualifyingData = qualifyingQuestionsData.map((q) => {
      if (q.consumer_map_field === "custom") {
        const newOptions = [...q.options];
        newOptions[index] = { ...newOptions[index], [field]: value };
        if (field === "title") {
          newOptions[index].value = value;
        }
        return { ...q, options: newOptions };
      }
      return q;
    });
    dispatch(setQualifyingQuestionsData(updatedQualifyingData));
  };

  const handleAddQualifyingOption = () => {
    setQualifyingGroup((prev) => ({
      ...prev,
      options: [
        ...prev.options,
        {
          title: "New Option",
          checked: true,
          description: "",
          value: "New Option",
          min_value: 0,
          max_value: 0,
        },
      ],
    }));

    const updatedQualifyingData = qualifyingQuestionsData.map((q) => {
      if (q.consumer_map_field === "custom") {
        return {
          ...q,
          options: [
            ...q.options,
            {
              title: "New Option",
              checked: true,
              description: "",
              value: "New Option",
              min_value: 0,
              max_value: 0,
            },
          ],
        };
      }
      return q;
    });
    dispatch(setQualifyingQuestionsData(updatedQualifyingData));
  };

  const handleDeleteQualifyingOption = (index) => {
    setQualifyingGroup((prev) => ({
      ...prev,
      options: prev.options.filter((_, i) => i !== index),
    }));

    const updatedQualifyingData = qualifyingQuestionsData.map((q) => {
      if (q.consumer_map_field === "custom") {
        return {
          ...q,
          options: q.options.filter((_, i) => i !== index),
        };
      }
      return q;
    });
    dispatch(setQualifyingQuestionsData(updatedQualifyingData));
  };

  // const sortFilters = (filters) => {
  //   const order = { age: 1, gender: 2 };
  //   return [...filters].sort((a, b) => {
  //     return (order[a] || 3) - (order[b] || 3);
  //   });
  // };

  const renderFilter = (filterKey) => {
    const segment = custom_segmentations.find(
      (s) => s.consumer_map_field === filterKey
    );
    if (!segment || segment.consumer_map_field === "custom") return null;

    const allChecked = segment.options.every((opt) => opt.checked);
    const sortedOptions = sortOptionsWithOthersLast(segment.options);

    return (
      <div
        key={filterKey}
        className="bg-white p-4 rounded-md border border-solid border-stone-200 mt-4"
      >
        <LoadingCommon statusLoading={isLoadingSegmentData} />
        <div className="flex justify-between items-center mb-2">
          <label className="flex items-center space-x-2">
            <CheckboxCommon
              checked={allChecked}
              onCheckedChange={() => handleAllCheckboxChange(filterKey)}
              className="rounded-none w-4 h-4 bg-white border border-solid border-black data-[state=checked]:bg-white data-[state=checked]:text-black"
            />
            <span className="font-medium text-gray-700">{segment.name}</span>
          </label>
          <button
            onClick={() => {
              setCurrentFilterKey(filterKey);
              removeSegmanModalRef.current.openModal();
            }}
            className="text-red-600 hover:text-red-800"
          >
            <img src={images.TrashIconRed} alt="Delete" className="w-5 h-5" />
          </button>
        </div>
        {sortedOptions?.length > 0 ? (
          sortedOptions.map((item, sortedIndex) => (
            <div key={`${filterKey}-${item.title}`} className="mb-4 pl-6">
              <label className="flex items-center space-x-2">
                <CheckboxCommon
                  checked={item.checked || false}
                  onCheckedChange={() =>
                    handleCheckboxChange(filterKey, sortedIndex)
                  }
                  className="rounded-none w-4 h-4 bg-white border border-solid border-black data-[state=checked]:bg-white data-[state=checked]:text-black"
                />
                <span className="text-sm font-medium text-gray-700">
                  {item.title}
                </span>
              </label>
            </div>
          ))
        ) : (
          <p className="text-sm text-gray-600">
            {t("quest.segmentSection.noOptionAvailable")}
          </p>
        )}
        {["age", "gender"].includes(filterKey) ? (
          <button className="text-sm text-black hover:underline flex items-center">
            {t("quest.segmentSection.autoFilter")}
          </button>
        ) : (
          <div className="flex flex-col gap-2">
            <h6 className="text-sm">
              {t("quest.segmentSection.qualifyingQuestion")} (
              {t("quest.segmentSection.filter")})
            </h6>
            <span className="text-sm">
              {t("quest.segmentSection.pleaseIndicateYour")} {segment.name}{" "}
              {t("quest.segmentSection.preference")}.
            </span>
          </div>
        )}
      </div>
    );
  };
  const renderQualifyingGroup = () => {
    const sortedOptions = sortOptionsWithOthersLast(qualifyingGroup.options);
    return (
      <div className="bg-white p-4 rounded-md border border-solid border-stone-200 mt-4">
        <div className="flex flex-col gap-2">
          <div className="flex flex-row justify-between">
            {" "}
            <div className="bg-amber-200 text-gray-800 px-4 py-1 rounded-md flex justify-between items-center cursor-pointer max-w-[100px]">
              <span>mcq</span>
              <img
                src={images.ChevronDownIcon}
                alt=""
                className="w-4 h-4 ml-2"
              />
            </div>
            <div className="flex items-center space-x-2">
              <button
                onClick={() => setIsEditingQualifying(!isEditingQualifying)}
                className="text-sm text-indigo-600 hover:underline"
              >
                {isEditingQualifying ? (
                  <>
                    <img
                      src={images.SaveDraftIcon}
                      alt=""
                      className="w-[18px]"
                    />
                  </>
                ) : (
                  <>
                    <img
                      src={images.PencilIconBlue}
                      alt=""
                      className="w-[18px]"
                    />
                  </>
                )}
              </button>
              {/* <img src={images.InfoCircleIcon} alt="Info" className="w-4 h-4" /> */}
            </div>
          </div>
          <span className="text-sm text-gray-400 px-2">
            {t("quest.segmentSection.qualifyingQuestion")}
          </span>

          <div className="flex justify-between items-center mb-2 gap-2 px-2">
            <input
              type="text"
              value={qualifyingGroup.title}
              onChange={handleQualifyingTitleChange}
              disabled={!isEditingQualifying}
              className={`font-medium text-gray-700 rounded p-1 w-full focus:outline-none ${
                isEditingQualifying
                  ? "border border-solid border-gray-300"
                  : "border-none"
              }`}
            />
          </div>
        </div>

        {sortedOptions.map((item, index) => {
          const originalIndex = qualifyingGroup.options.findIndex(
            (opt) => opt.title === item.title
          );

          return (
            <div
              key={originalIndex}
              className="mb-4 flex items-center space-x-2 px-2"
            >
              <CheckboxCommon
                checked={item.checked}
                onCheckedChange={() =>
                  handleQualifyingOptionChange(
                    originalIndex,
                    "checked",
                    !item.checked
                  )
                }
                disabled={!isEditingQualifying}
                className="rounded-none w-4 h-4 bg-white border border-solid border-black data-[state=checked]:bg-white data-[state=checked]:text-black"
              />
              <input
                type="text"
                value={item.title}
                onChange={(e) =>
                  handleQualifyingOptionChange(
                    originalIndex,
                    "title",
                    e.target.value
                  )
                }
                disabled={!isEditingQualifying}
                className={`text-sm font-medium text-gray-700 focus:outline-none rounded p-1 flex-1  ${
                  isEditingQualifying
                    ? "border border-solid border-gray-300"
                    : "border-none"
                }`}
              />
              {isEditingQualifying && (
                <button
                  onClick={() => handleDeleteQualifyingOption(originalIndex)}
                  className="text-red-600 hover:text-red-800"
                >
                  <img
                    src={images.TrashIconRed}
                    alt="Delete"
                    className="w-4 h-4"
                  />
                </button>
              )}
            </div>
          );
        })}
        {isEditingQualifying && (
          <button
            onClick={handleAddQualifyingOption}
            className="text-sm text-indigo-600 hover:underline mb-2"
          >
            + {t("quest.addOption")}
          </button>
        )}
      </div>
    );
  };

  const selectOptions = [
    ...filterOptions,
    {
      value: "custom",
      label: qualifyingGroup.title,
    },
  ];

  return (
    <div className="p-4">
      <div className="mb-4">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-gray-600">
            {t("quest.segmentSection.segmentationFilters")}
          </span>
        </div>
        <div className="w-full">
          <FormSelectSegmentation
            value={selectedFilters}
            onChange={(e) => handleFilterSelect(e.target.value)}
            options={selectOptions}
            className="mt-0 bg-stone-100 text-black text-sm font-medium"
          />
        </div>
        {selectedFilters.map((filterKey) => renderFilter(filterKey))}
      </div>

      {selectedFilters.includes("custom") && renderQualifyingGroup()}

      <CommonModal
        ref={removeSegmanModalRef}
        title={
          <>
            <div className="">
              {t("quest.segmentSection.doYouWantToRemoveThisFilter")}
            </div>
          </>
        }
        onOverlayAction={() => onKeepSegman()}
        actions={(closeModal) => (
          <>
            <Button
              text="Keep"
              className="flex-1 shrink gap-2.5 self-stretch px-5 py-3 rounded-xl min-h-[40px] text-white bg-[#3F54DF]"
              onClick={() => onKeepSegman()}
            />
            <Button
              text="Remove"
              className="flex-1 shrink gap-2.5 self-stretch px-5 py-3 rounded-xl min-h-[40px] bg-[#EEEAE8] border border-solid border-stone-200 text-[#3F54DF]"
              variant="primary"
              onClick={() => onRemoveSegman()}
            />
          </>
        )}
      />

      <CommonModal
        ref={addFilterModalRef}
        title={
          <div className="text-sm font-medium text-gray-600">
            {t("quest.segmentSection.addFilter")}
          </div>
        }
        onOverlayAction={handleApplySelectedGroups}
      >
        <div className="flex flex-col gap-2">
          {filterOptions.map((option) => (
            <div
              key={option.value}
              className="flex justify-between items-center py-2 border-b border-gray-200 cursor-pointer"
              onClick={() => handleToggleGroupSelection(option.value)}
            >
              <span className="text-sm text-gray-700">{option.label}</span>
              {(modalSelectedGroups.has(option.value) ||
                selectedFilters.includes(option.value)) && (
                <img src={images.CheckIconBlack} className="w-[20px]" alt="" />
              )}
            </div>
          ))}
        </div>
      </CommonModal>
    </div>
  );
};

export default SegmentationFilters;
